import { usd, fecha } from "./util";
import { pctTxt } from "./graf";

const R = 26, C = 2 * Math.PI * R;

export const Proximo = ({ d }) => {
  const prox = (d.vencimientos || []).filter((v) => v.fecha && v.dias <= 0).sort((a, b) => b.dias - a.dias)[0];
  if (!prox) return null;
  const faltan = -prox.dias, p = Math.max(0, Math.min(1, 1 - faltan / 30));
  return (
    <div className="rg-prox rg-sec" data-testid="resumen-proximo">
      <svg viewBox="0 0 64 64" width="64" height="64" aria-label={`Faltan ${faltan} días`}>
        <circle cx="32" cy="32" r={R} stroke="#33402F" strokeWidth="6" fill="none" />
        <circle cx="32" cy="32" r={R} stroke={faltan <= 7 ? "#D2A23A" : "#7DBEE6"} strokeWidth="6" fill="none" strokeLinecap="round" className="rg-traza" style={{ strokeDasharray: C, strokeDashoffset: C - C * p, "--largo": C }} transform="rotate(-90 32 32)" />
        <text x="32" y="30" textAnchor="middle" fill="#EEF3EC" fontSize="16" fontWeight="800">{faltan}</text>
        <text x="32" y="42" textAnchor="middle" fill="#A9B8A5" fontSize="7" fontWeight="700">DÍAS</text>
      </svg>
      <div>
        <small>Próximo vencimiento</small>
        <b data-testid="resumen-proximo-monto">{usd(prox.monto)}</b>
        <span>{fecha(prox.fecha)} · {prox.facturas || 1} factura{prox.facturas === 1 ? "" : "s"} · {pctTxt(prox.monto, d.saldo)} del saldo</span>
      </div>
    </div>
  );
};
